import React from 'react';
import ColumnText from './ColumnText';
import HeaderColumnCell from './HeaderColumnCell';
import SortIcon from './SortIcon';
import useTranslate from '../../customHooks/useTranslate';

const SortableDateTimeColumn = props => {
    const {
        labelText,
        isLoading,
        sortDir,
        isSorted,
        sortByField,
        sortableProps,
        titleText,
        ...restProps
    } = props;

    const { sortKey, defaultSortDir = 'asc' } = sortableProps;

    const handleSort = () => sortByField(sortKey, defaultSortDir);
    const onClick = !isLoading ? handleSort : undefined;

    const titleTextHelper = useTranslate('time_zone_column_helper');

    return (
        <HeaderColumnCell
            role='button'
            onClick={onClick}
            data-is-loading={isLoading}
            {...restProps}
        >
            <ColumnText
                labelText={labelText}
                titleText={titleTextHelper || titleText}
            />
            <div className='header-column__sortable-date-time'>
                <SortIcon sortDir={sortDir} isSorted={isSorted} />
            </div>
        </HeaderColumnCell>
    );
};

export default SortableDateTimeColumn;
